(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["vue-input"] = factory();
	else
		root["vue-input"] = factory();
})((typeof self !== 'undefined' ? self : this), () => {
return /******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	// The require scope
/******/ 	var __webpack_require__ = {};
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/publicPath */
/******/ 	(() => {
/******/ 		__webpack_require__.p = "";
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": () => (/* binding */ entry_lib)
});

;// CONCATENATED MODULE: ../../node_modules/@vue/cli-service/lib/commands/build/setPublicPath.js
/* eslint-disable no-var */
// This file is imported into lib/wc client bundles.

if (typeof window !== 'undefined') {
  var currentScript = window.document.currentScript
  if (false) { var getCurrentScript; }

  var src = currentScript && currentScript.src.match(/(.+\/)[^/]+\.js(\?.*)?$/)
  if (src) {
    __webpack_require__.p = src[1] // eslint-disable-line
  }
}

// Indicate to webpack that this file can be concatenated
/* harmony default export */ const setPublicPath = (null);

;// CONCATENATED MODULE: ../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[2]!../../node_modules/pug-plain-loader/index.js!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/VueInput.vue?vue&type=template&id=7c061b16&scoped=true&lang=pug&
var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sf-input",class:{ 'sf-input--prefixed': _vm.prefix, 'sf-input--postfixed': _vm.postfix, 'sf-input--error': _vm.hasError, 'sf-input--focused': _vm.isFocused }},[(_vm.label && _vm.hasTooltipSlot)?[_c('div',{staticClass:"sf-input__label"},[_c('label',{attrs:{"id":_vm.uuid + '-label',"for":_vm.uuid}},[_vm._v(_vm._s(_vm.label))]),_vm._t("tooltip")],2)]:(_vm.label && !_vm.hasTooltipSlot)?[_c('label',{attrs:{"id":_vm.uuid + '-label',"for":_vm.uuid}},[_vm._v(_vm._s(_vm.label))])]:void 0,_c('div',{staticClass:"sf-input__wrapper",style:({ maxWidth: _vm.maxWidthStyle })},[_c('input',_vm._g(_vm._b({ref:"input",class:{ 'sr-only': _vm.$attrs['readonly'] },style:({ paddingRight: _vm.paddingRight + 'px' }),attrs:{"id":_vm.uuid,"type":_vm.type,"aria-invalid":_vm.hasError ? 'true' : false,"aria-labelledby":_vm.label ? _vm.uuid + '-label' : false,"aria-describedby":_vm.ariaDescribedBy ? _vm.ariaDescribedBy : false,"maxlength":_vm.maxLength},domProps:{"value":_vm.value},on:{"focus":function($event){_vm.isFocused = true},"blur":function($event){_vm.isFocused = false}}},'input',_vm.$attrs,false),_vm.inputListeners)),(_vm.prefix)?_c('span',{staticClass:"sf-input__prefix",attrs:{"id":_vm.computedPrefixId}},[_vm._v(_vm._s(_vm.prefix)),_c('span',{staticClass:"sr-only"},[_vm._v("nélkül")])]):_vm._e(),(_vm.$attrs['readonly'])?_c('span',{staticClass:"sf-input__value",attrs:{"aria-hidden":"true"}},[(_vm.prefix)?[_vm._v(" ")]:_vm._e(),_vm._v(_vm._s(_vm.value)),(_vm.postfix)?[_vm._v(" ")]:_vm._e()],2):_vm._e(),(_vm.postfix)?_c('span',{staticClass:"sf-input__postfix"},[_vm._v(_vm._s(_vm.postfix))]):_vm._e()]),(_vm.addon || _vm.hasCounter)?_c('i',{style:(_vm.maxWidthStyle),attrs:{"id":_vm.computedAddonId}},[(_vm.addon)?_c('span',{staticClass:"sf-input__addon"},[_vm._v(_vm._s(_vm.addon))]):_vm._e(),(_vm.hasCounter)?_c('span',{staticClass:"sf-input__counter"},[_vm._v(_vm._s(this.value && this.value.length || 0)),(_vm.maxLength)?[_vm._v("/"+_vm._s(_vm.maxLength))]:_vm._e()],2):_vm._e()]):_vm._e()],2)
}
var staticRenderFns = []


;// CONCATENATED MODULE: ../../node_modules/@ui-common/sf-js-utils/dist/sf-js-utils.esm.js
var t=Object.freeze({__proto__:null,ADDRESS_CARD:"^\\d{6}[a-zA-Z]{2}$",ALL_PHONE:["^1\\s\\d{3}\\s\\d{4}$","^[02-9]\\d\\s\\d{3}\\s\\d{3,4}$","^(70|20|30|31)\\s\\d{3}\\s\\d{4}$"],BANK_ACCOUNT_SIXTEEN_NUMBERS:"^\\d{8}-\\d{8}$",BANK_ACCOUNT_THIRTEEN_NUMBERS:"^\\d{5}-\\d{8}$",BANK_ACCOUNT_TWENTY_FOUR_NUMBERS:"^\\d{8}-\\d{8}-\\d{8}$",DATE_SEPARATORS:/[.,\/ -]/,DEVIZA_BANK_ACCOUNT_NUMBER_PATTERN:"^75\\d{3}-\\d{5}88\\d$",FOREIGN_PHONE_REGEX:/^\d{1,3}-\d{1,10}$/,FOREIGN_ZIP_CODE:/^[\da-zA-Z]{1,10}$/g,FULLNAME:"^(.+[ ].+)$|^$",HEX:/#[0-9a-fA-F]{6}/,IDENTITYS:{"personal-id":"^\\d{6}[a-zA-Z]{2}$","drivers-license":"^[a-zA-Z]{2}\\d{6}$",passport:"[a-zA-Z]{2}\\d{7}$"},IOS:/ipad|iphone/i,LANDLINE_PHONES:["^1\\s\\d{3}\\s\\d{4}$","^[02-9]\\d\\s\\d{3}\\s\\d{3,4}$"],LAST_FOUR_DIGITS:/^\d{4}$/,MOBILE_PHONE:"^(70|20|30|31)\\s\\d{3}\\s\\d{4}$",NAME:"^[\\p{L}\\s\\.\\-\\']*$",PENSIONER_NUMBER:"^\\d{3}-\\d{5}-\\d{1}$",TAX_NUMBER:"^\\d{8}-\\d{1}-\\d{2}$",YEAR:"^\\d{4}$",ZIP_CODE:"^\\d{4}$"});var e=Object.freeze({__proto__:null,HUNGARIAN_PHONE_NUMBER_PREFIX:"+36",OTP_BANK_ACCOUNT_NUMBER_PREFIX:"117"});var r=Object.freeze({__proto__:null,COOKIE_GDPR_LEVEL:"gdpr_level",GDPR_LEVELS:{LOW:1,MEDIUM:2,HIGH:3}});var d=Object.freeze({__proto__:null,BACKEND_DATE:"YYYY-MM-DD",DISPLAY_DATE:{hu:"YYYY.MM.DD.",en:"MM/DD/YYYY"},DISPLAY_TIME:{hu:"HH:mm",en:"hh:mm A"}});function i(){window.onkeydown=function(t){"Space"===t.code&&t.target==document.body&&t.preventDefault()}}function o(t){for(var e=0,r=0;t;){if("BODY"==t.tagName){var d=t.scrollLeft||document.documentElement.scrollLeft,i=t.scrollTop||document.documentElement.scrollTop;e+=t.offsetLeft-d+t.clientLeft,r+=t.offsetTop-i+t.clientTop}else e+=t.offsetLeft-t.scrollLeft+t.clientLeft,r+=t.offsetTop-t.scrollTop+t.clientTop;t=t.offsetParent}return{x:e,y:r}}function s(t){let e=[],r=t.parentNode.firstChild;for(;r;)1===r.nodeType&&r!==t&&e.push(r),r=r.nextSibling;return e}function n(t,e,r){return r=r?parseInt(r,10):0,"number"==typeof e?t.slice(r,r+e):t}function p(t){return void 0!==t&&null!=t?Math.floor(t/12)+" év":""}const u=767,_=959,h=1279;var a={data:()=>({viewportWidth:null}),methods:{setViewportWidth(){this.viewportWidth=window.innerWidth}},computed:{isMobile(){return this.viewportWidth<=u},isTablet(){return this.viewportWidth>u&&this.viewportWidth<_},isDesktop(){return this.viewportWidth>_&&this.viewportWidth<h},isLargeDesktop(){return this.viewportWidth>h}},created(){window.addEventListener("resize",this.setViewportWidth),this.setViewportWidth()},mounted(){this.setViewportWidth()},beforeDestroy(){window.removeEventListener("resize",this.setViewportWidth)}},E=(t=8)=>{let e="";const r="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";for(let d=0;d<t;d++)e+=r.charAt(Math.floor(62*Math.random()));return e},l={data(){return{uuid:this.id||E()}},props:{id:{required:!1,type:String}}},N={mixins:[l],props:{errorId:{required:!1,type:String},addonId:{required:!1,type:String},prefixId:{required:!1,type:String},tooltipId:{required:!1,type:String},addon:{type:String,required:!1},prefix:{type:String,required:!1}},computed:{computedAddonId(){const t=this.addon?`${this.uuid}-addon`:null;return this.addonId||t},computedPrefixId(){const t=this.prefix?`${this.uuid}-prefix`:null;return this.prefixId||t},ariaDescribedBy(){const t=[];return this.$attrs["aria-describedby"]&&t.push(this.$attrs["aria-describedby"]),this.errorId&&t.push(this.errorId),this.computedAddonId&&t.push(this.computedAddonId),this.computedPrefixId&&t.push(this.computedPrefixId),this.tooltipId&&t.push(this.tooltipId),t.join(" ")}}},c={props:{hasError:{type:Boolean,required:!1,default:!1}}};

;// CONCATENATED MODULE: ../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/VueInput.vue?vue&type=script&lang=js&


/* harmony default export */ const VueInputvue_type_script_lang_js_ = ({
	mixins: [c, N, a],
	inheritAttrs: false,
	name: 'VueInput',
	data: () => ({
		isFocused: false
	}),
	props: {
		/**
		 * @model
		 */
		value: {
			required: true
		},
		/**
		 * Type of the input
		 */
		type: {
			required: false,
			default: 'text',
			type: String
		},
		/**
		 * Label of the input
		 */
		label: {
			required: false,
			type: String
		},
		/**
		The maximum width of the input
		*/
		maxWidth: {
			type: Number
		},
		/**
		Native maxlength attribute of input
		*/
		maxLength: {
			type: Number
		},
		/**
		Full width on mobile
		*/
		fullWidthMobile: {
			type: Boolean
		},
		/**
		postfix text of the input
		*/
		postfix: {
			type: String,
			required: false
		},
		/**
		prefix text of the input
		*/
		prefix: {
			type: String,
			required: false
		},
		/**
		If true charachter counter appears on input
		*/
		hasCounter: {
			type: Boolean,
			required: false,
			default: false
		},
		/**
		Add padding right in inline-style onto the input
		*/
		paddingRight: {
			type: Number,
			reqired: false,
			default: 0
		}
	},
	computed: {
		inputListeners() {
			const vm = this;
			return Object.assign({}, this.$listeners, {
				input(event) {
					vm.$emit('input', event.target.value);
					if (event.target.value.length == vm.maxLength) {
						vm.$emit('maxlength-reached');
					}
				}
			});
		},
		hasTooltipSlot() {
			return !!this.$slots['tooltip'];
		},
		maxWidthStyle() {
			return this.fullWidthMobile && this.isMobile && this.maxWidth ? null : `${this.maxWidth}px`;
		},
		addonMaxWidthStyle() {
			return this.hasCounter ? `max-width: ${this.maxWidth}px` : null;
		}
	}
});

;// CONCATENATED MODULE: ./src/components/VueInput.vue?vue&type=script&lang=js&
 /* harmony default export */ const components_VueInputvue_type_script_lang_js_ = (VueInputvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

function normalizeComponent(
  scriptExports,
  render,
  staticRenderFns,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */,
  shadowMode /* vue-cli only */
) {
  // Vue.extend constructor export interop
  var options =
    typeof scriptExports === 'function' ? scriptExports.options : scriptExports

  // render functions
  if (render) {
    options.render = render
    options.staticRenderFns = staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = 'data-v-' + scopeId
  }

  var hook
  if (moduleIdentifier) {
    // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = shadowMode
      ? function () {
          injectStyles.call(
            this,
            (options.functional ? this.parent : this).$root.$options.shadowRoot
          )
        }
      : injectStyles
  }

  if (hook) {
    if (options.functional) {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functional component in vue file
      var originalRender = options.render
      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context)
        return originalRender(h, context)
      }
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook]
    }
  }

  return {
    exports: scriptExports,
    options: options
  }
}

;// CONCATENATED MODULE: ./src/components/VueInput.vue



;


/* normalize component */

var component = normalizeComponent(
  components_VueInputvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  "7c061b16",
  null
  
)

/* harmony default export */ const VueInput = (component.exports);
;// CONCATENATED MODULE: ../../node_modules/@vue/cli-service/lib/commands/build/entry-lib.js


/* harmony default export */ const entry_lib = (VueInput);


__webpack_exports__ = __webpack_exports__["default"];
/******/ 	return __webpack_exports__;
/******/ })()
;
});
//# sourceMappingURL=vue-input.umd.js.map